class LocalisationForm extends HTMLElement {
  constructor() {
    super();

    this.DROPDOWN_ACTIVE = "localisation__select--active";

    this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
    this.select = this.querySelector(".js-select");
    this.items = this.querySelectorAll(".js-localisation-item");
    this.panel = this.querySelector(".localisation__list");

    this.addListeners();
  }

  addListeners() {
    this.addEventListener("keyup", event => this.onContainerKeyUp(event));
    this.items.forEach(item => item.addEventListener("click", event => this.onItemClick(event)));
    this.select.addEventListener("click", event => {
      event.stopPropagation();

      this.toggleSelector();
    });

    document.addEventListener("click", () => {
      if (this.closest(".js-select")) return;

      this.closeSelector();
    });
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.toggleSelector();
    this.panel.focus();
  }

  onItemClick(event) {
    event.preventDefault();

    const form = this.querySelector(".js-localisation");

    this.input.value = event.currentTarget.dataset.value;

    if (form) form.submit();
  }

  toggleSelector() {
    this.select.classList.toggle(this.DROPDOWN_ACTIVE);
  }

  closeSelector() {
    this.select.classList.remove(this.DROPDOWN_ACTIVE)
  }
}

customElements.define("localisation-form", LocalisationForm);
